import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { breakpoint, fontSize } from '@twistopayments/design-system/styles';

export const input = (theme: Theme) => css`
  display: grid;
  position: relative;
  align-items: center;
  justify-items: center;
  width: 100%;
  height: ${theme.spacing[48]};
  background-color: ${theme.palette.tertiary.lowContrast};
  border-radius: ${theme.borderRadius.sm};
  border: none;
  text-align: center;
  padding: ${theme.spacing[0]} ${theme.spacing[16]};
  font-weight: 700;
  font-size: ${fontSize.sm};
  color: ${theme.palette.text.title};

  ${breakpoint.up('md')} {
    font-size: ${fontSize.smMd};
    padding: ${theme.spacing[0]} ${theme.spacing[24]};
  }
`;

export const disabled = (theme: Theme) => css`
  color: ${theme.palette.text.disabled};
  cursor: not-allowed;
`;
